export const privacyEmail = 'privacidad@bspos.mx'
export const privacyLastUpdated = '30 de octubre de 2026'

export const supportEmail = 'soporte@bspos.mx'
export const supportPhone = '3349014588'
export const supportPhoneDisplay = '33 4901 4588'
/** The support bot's username on Telegram, without the @; empty, the footer does not offer it. */
export const supportTelegram = 'BsPOSSoporteBot'

export const termsLastUpdated = '13 de octubre de 2026'
/** The version of the terms a contracting accepts; the server refuses any other. */
export const termsVersion = '2026-10-13'
